import { useCallback } from 'react';
import { useAuth } from '@/features/auth/AuthContext';
import { isAutonomyLevelEnabled, isTaskTypeEnabled } from '@/shared/domain/workspaceFeatures';

/**
 * SaaS gating for task-creation controls. `gated` is true on the SaaS
 * deployment, where a workspace may only use the task types and autonomy
 * levels a god enabled for it (`workspace.features`; Classification and "no
 * tool calling" are always allowed). `isTaskTypeAllowed` /
 * `isAutonomyLevelAllowed` answer per option; `contactUs` is the modal opener
 * whenever gated, so the "Contact us" link is always offered on SaaS (the
 * modal reports a filing failure itself if the backend is not configured).
 * Off SaaS everything is allowed and `contactUs` is inert.
 */
export default function useSaasGating(onContactUs) {
    const auth = useAuth();
    const gated = auth?.isSaas === true;
    const features = auth?.workspace?.features;
    const contactUs = gated ? onContactUs : undefined;
    const isTaskTypeAllowed = useCallback(
        (taskType) => !gated || isTaskTypeEnabled(taskType, features),
        [gated, features],
    );
    const isAutonomyLevelAllowed = useCallback(
        (level) => !gated || isAutonomyLevelEnabled(level, features),
        [gated, features],
    );
    return { gated, contactUs, isTaskTypeAllowed, isAutonomyLevelAllowed };
}
